module.exports = __webpack_public_path__ + "img/gift-coin.1aa97bde.svg";